export default __webpack_public_path__ + "static/media/cam.7cfe0705.jfif";